import React, { useEffect, useState, useContext } from "react";
import { TrashIcon } from "@heroicons/react/24/outline";
import Button from "../material/button/Button";
import * as medicalApi from "../../service/medicalApi";
import ModalUploadFileV2 from "../material/modal/ModalUploadFileV2";
import moment from "moment";
import "moment/locale/th";
import { useLocation, useNavigate } from "react-router-dom";
import { RedirectCode400 } from "../RedirectCode400";
import { CurrentUserContext } from "../../App";
import styles from "./GuidelineTextEditor.module.css";

import DialogTailwindConfirm from "../DialogTailwindConfirm";
import TableSearchV1 from "../tableV1/tableSearchV1";
import { FaTrashAlt, FaEye } from "react-icons/fa";
const customStyles = {
  rows: {
    style: {
      // override the row height
      "&:nth-child(even)": {
        background: "#effff4",
      },
      "&:not(:last-of-type)": {
        borderBottomWidth: "none",
      },
    },
  },
  headCells: {
    style: {
      // override the cell padding for head cells
      display: "flex",
      justifyContent: "center",
      background: "#B8DFC7",
      fontSize: 18,
      "@media (max-width: 800px)": {
        fontSize: 14,
      },
    },
  },
  cells: {
    style: {
      // override the cell padding for data cells
      display: "flex",
      justifyContent: "center",
      borber: "1px solid #B8DFC7",
    },
  },
};

const Document = () => {
  const { setIsMessage } = useContext(CurrentUserContext);

  const [documentList, setDocumentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [openModalUploadFile, setOpenModalUploadFile] = useState(false);
  const [date, setDate] = useState("");
  const [total, setTotal] = useState(null);
  const [filters, setFilters] = useState({});
  const [selectedData, setSelectedData] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [sortBy, setSortBy] = useState({ id: "", desc: false });

  const location = useLocation();
  const nav = useNavigate();

  useEffect(() => {
    setDate(moment().add(543, "years").format("D MMMM YYYY"));
  }, []);

  useEffect(() => {
    getDocumentList();
  }, [page, sortBy]);

  const getDocumentList = async () => {
    setLoading(true);
    let res = await medicalApi.getDocument(page, 10, sortBy.id, sortBy.desc ? "desc" : "asc");
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setDocumentList(res["data"]["document_list"]);
        setMaxPage(Math.ceil(res["data"]["amount"] / 10));

        setTotal(res["data"]["amount"]);
      } else if (res["data"]["code"] === 403) {
        nav(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };
  // ฟังก์ชันเปิด dialog พร้อมบันทึกข้อมูล row ที่ต้องการ
  const openDialog = (rowData) => {
    setSelectedData(rowData);
    setIsDialogOpen(true);
  };

  //เปิด Dialog
  const handleConfirmRemove = async (confirmed, data) => {
    setIsDialogOpen(false);
    if (confirmed && data) {
      if (data?.document_id) {
        let res = await medicalApi.removeDocument(data?.document_id);

        if (res) {
          if (res["data"]["code"] === 200) {
            getDocumentList();
          } else if (res["data"]["code"] === 403) {
            nav(RedirectCode400());
          } else {
            setIsMessage({
              type: "warning",
              data: res["data"]["message_th"] || res["data"]["message"],
            });
          }
        } else {
          setIsMessage({
            type: "error",
            data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
          });
        }
      }
    }
  };

  const addDocument = async (event) => {
    let formData = new FormData();
    formData.append("file", event.file);
    formData.append("file_name", event.inputValue);
    setLoading(true);
    let res = await medicalApi.addDocument(formData);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({ type: "success", data: "สำเร็จ" });
        setOpenModalUploadFile(false);
        getDocumentList();
      } else if (res["data"]["code"] === 403) {
        nav(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const handleSortChange = (id, desc) => {
    setPage(1);
    setSortBy({ id, desc });
  };

  const columnsDoc = [
    {
      Header: "No.",
      accessor: "id",
      Filter: "#",
    },
    {
      Header: "หัวข้อ",
      accessor: "document_name",
      Cell: ({ row }) => {
        return (
          <div
            className="cursor-pointer text-[#000000] text-left"
            onClick={() => {
              window.open(row.original.document_file);
            }}
          >
            {row.original.document_name}
          </div>
        );
      },
      Filter: "text",
      wrap: true,
    },
    {
      Header: "#",
      disableSortBy: true,
      accessor: "document_id",
      Cell: ({ row }) => {
        return (
          <div className="flex flex-row justify-center items-center gap-[6px]">
            <div
              className="flex justify-center items-center h-[30px] p-2 rounded-[5px]"
              style={{ background: "#DFEEFA 0% 0% no-repeat padding-box" }}
              onClick={() => {
                window.open(row.original.document_file);
              }}
            >
              <FaEye className="text-[#46A8F4] h-[14px]" />
            </div>
            <button
              className="text-red bg-red-100 border font-medium rounded-[5px] text-sm p-2"
              onClick={() =>
                openDialog({
                  message: `คุณต้องการลบใช่หรือไม่`,
                  row: row.original,
                })
              }
            >
              <FaTrashAlt style={{ width: "18px" }} color="#d32736" />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <div class="flex w-full bg-[#ffffff] pb-[30px]">
      <div className={styles.blockContent}>
        <div
          className={`text-3xl md:text-[18px] flex font-bold mt-2 mb-4 font-['Prompt-SemiBold']`}
        >
          รายการเอกสารที่เกี่ยวข้องทั้งหมด{" "}
          <span className={styles.fontDate}>(ข้อมูลวันที่ {date})</span>
        </div>

        <div className="my-4">
          <div className={styles.fontSub}>
            ท่านสามารถคลิกหรือเพิ่มเอกสารที่เห็นว่าเป็นประโยชน์ต่อบุคลากรทางแพทย์ได้ที่นี่
          </div>
        </div>

        <TableSearchV1
          columns={columnsDoc}
          data={documentList}
          filters={filters}
          setFilters={setFilters}
          loading={loading}
          total={total}
          page={page}
          maxPage={maxPage}
          setPage={setPage}
          sortBy={sortBy}
          onSortChange={handleSortChange}
          addData={{
            name: "เพิ่มไฟล์เอกสาร",
            state: () => setOpenModalUploadFile(true),
          }}
          noDataComponent={<div className="w-full text-left">ไม่พบข้อมูล</div>}
        />

        <ModalUploadFileV2
          show={openModalUploadFile}
          title={"อัพโหลดไฟล์เอกสาร"}
          placeholder={"ชื่อเอกสาร"}
          titlename={"อัพโหลดไฟล์เอกสาร"}
          onSubmit={addDocument}
          onClose={() => {
            setOpenModalUploadFile(false);
          }}
        />
      </div>
      {/* เปิด DialogTailwindConfirm พร้อมส่งข้อมูล row ที่เลือก */}
      {isDialogOpen && selectedData && (
        <DialogTailwindConfirm
          onConfirm={handleConfirmRemove}
          onCancel={handleConfirmRemove}
          data={selectedData}
        />
      )}
    </div>
  );
};

export default Document;
